import classNames from 'classnames';
// import PropTypes from 'prop-types';
import React from 'react';
import {prefix} from '../../wui-core/src/config/updatePrefix';
import type {InputGroupAddonProps} from './iInputGroup'

const InputGroupAddon = React.forwardRef<HTMLSpanElement, InputGroupAddonProps>((props, ref) => {
    let {className, clsPrefix, addonType, ...others} = props;
    clsPrefix = clsPrefix || (addonType === 'button' ? `${prefix}-input-group-btn` : `${prefix}-input-group-addon`);

    return <span ref={ref} {...others} className={classNames(className, clsPrefix)} />;
});

InputGroupAddon.displayName = 'InputGroupAddon';

export default InputGroupAddon;